'use client';

import { useState } from 'react';

import VerifyEmail from '@web/components/VerifyEmail';

import EmailSignUpForm from './EmailSignUpForm';

interface Props {
  allowRestrictedRegion?: boolean;
}

const EmailSignUpPage = ({ allowRestrictedRegion }: Props) => {
  const [email, setEmail] = useState<string | null>(null);

  if (!email) return <EmailSignUpForm setVerifyEmail={setEmail} allowRestricted={allowRestrictedRegion} />;
  return <VerifyEmail email={email} />;
};

export default EmailSignUpPage;
